import { render, staticRenderFns } from "./TranslateAction.vue?vue&type=template&id=beec4140"
import script from "./TranslateAction.vue?vue&type=script&lang=js"
export * from "./TranslateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports